import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import theme from "../../theme/theme";

import styled from "styled-components";

const ButtonWrapper = styled.button`
  display: flex;
  align-items: center;
  background-color: ${(props) =>
    `${props.type === "primary" ? theme.colors.primaryStrong2X : "white"}`};
  border: ${(props) =>
    `${
      props.type === "primary"
        ? "none"
        : `1px solid ${theme.colors.primaryStrong2X}`
    }`};
  padding: 15px 40px;
  color: ${(props) =>
    `${props.type === "primary" ? "white" : theme.colors.primaryStrong2X}`};
  border-radius: 5px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  @media (max-width: 480px) {
    padding: 10px 20px;
  }
`;

const CustomButton = ({
  text,
  onClick,
  buttonType = "primary",
  nextLogo,
  icon,
  isMaterialIcon = false,
}) => {
  return nextLogo ? (
    <ButtonWrapper onClick={onClick} type={buttonType}>
      <span>{text}</span> <FontAwesomeIcon icon={faAngleRight} />
    </ButtonWrapper>
  ) : (
    <ButtonWrapper onClick={onClick} type={buttonType}>
      {!isMaterialIcon ? (
        <FontAwesomeIcon
          icon={icon}
          style={{ fontSize: 15, color: "white", marginRight: "10px" }}
        />
      ) : (
        icon
      )}
      {text}
    </ButtonWrapper>
  );
};

export default CustomButton;
